import Vue from 'vue';
import Vuetify from 'vuetify/lib';

// import "C:/Users/bigoh/Downloads/fontawesome-pro-5.14.0-web/fontawesome-pro-5.14.0-web/css/all.min.css";
import '@/assets/css/all.min.css';
import '@morioh/v-lightbox/dist/lightbox.css';

import store from '@/store';
import moment from 'moment';
import axios from 'axios';
import VueAxios from 'vue-axios';
import router from '../router';
import VueLodash from 'vue-lodash';
import _lodash from 'lodash';
import VueCookies from 'vue-cookies';
import VueMoment from 'vue-moment';
import browserDetect from 'vue-browser-detect-plugin';
import platformPlugin from './platformPlugin';
import componentMatcherPlugin from './componentMatcher';
import utilityPlugin from './myPlugin';
import Vuebar from 'vuebar';
import vueFilterPrettyBytes from 'vue-filter-pretty-bytes';
import DatetimePicker from 'vuetify-datetime-picker';
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';
import VuePlyr from 'vue-plyr';
import Lightbox from '@morioh/v-lightbox'
import VueTheMask from 'vue-the-mask'

axios.interceptors.request.use(
  (config) => {
    const accToken = Vue.$cookies.get('user_token');
    if (accToken !== null && accToken !== undefined) {
      config.headers['x-session-token'] = `${accToken}`;
    } else if (config.method == 'get') {
      let companyID = null
      if (Vue.prototype.$userInfo && Vue.prototype.$userInfo.companies && Vue.prototype.$userInfo.companies[0]._id) {
        companyID = Vue.prototype.$userInfo.companies[0]._id
      }
      if (companyID) {
        let findSymbolQuery = config.url.indexOf('?')
        if (findSymbolQuery > -1) {
          config.url = `${config.url}&companyID=${companyID}`
        } else {
          config.url = `${config.url}?companyID=${companyID}`
        }
      }
    }
    config.headers['server-name'] = store.state.serverName;
    return config;
  },
  (err) => {
    return Promise.reject(err);
  },
);

axios.interceptors.response.use(
  (config) => {
    return config;
  },
  async (err) => {
    console.log(err);
    if (err.response.status === 401) {
      await $cookies.remove('user_token');

      console.log('clear user_token');
      await $cookies.remove('user_info');

      console.log('clear user_info');
      // await $router.replace({ name: "login" });
      window.location.href = `/login`;
      console.log('clear');
    } else {
      return Promise.reject(err);
    }
  },
);

Vue.use(VueAxios, axios);
Vue.use(Vuetify);
Vue.use(VueMoment, {
  moment,
});
const options = { lodash: _lodash };
Vue.use(VueLodash, options);
Vue.use(VueCookies);
Vue.use(browserDetect);
Vue.use(platformPlugin);
Vue.use(componentMatcherPlugin);
Vue.use(utilityPlugin);
Vue.use(Vuebar);
Vue.use(vueFilterPrettyBytes);
Vue.use(DatetimePicker);
Vue.use(VuePlyr, {
  plyr: {
    fullscreen: { enabled: true }
  },
  emit: ['ended']
});
Vue.use(Lightbox);
Vue.use(VueTheMask)

Vue.filter('capitalize', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

import en from '@/locales/en';
import th from '@/locales/th';
Vue.filter('numFormat', numFormat(numeral));

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

export default new Vuetify({
  lang: {
    locales: { en, th },
    current: 'en',
  },
  icons: {
    iconfont: 'fa',
  },
});
